<button
  type="button"
  class="btn btn-bg-color-from-db btn-sm gk-map-icon-remove bg-white text-secondary"
  [title]="'GK.MAP.CLEAR' | translate"
  [attr.aria-label]="'GK.MAP.CLEAR' | translate"
  (click)="clearMapObjects()"
></button>
